import { CommonModule } from '@angular/common';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { BookDemoDailogBoxComponent } from '../book-demo-dailog-box/book-demo-dailog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { PLAN_CODES } from '@edtech-ui/constants/upgrade-plan-code.enum';
import { UpgradePricePlan } from '@edtech-ui/constants/upgrade-price.enum';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { PaymentService } from '@edtech-ui/core/services/payment-management/payment.service';
import { ToastrService } from 'ngx-toastr';
import { CurrentSubscription, StudentDataPackageProduct } from '@edtech-ui/core/models/student-courses-v2/student-products-lists';
import { PaymentSuccessDialogComponent } from '@edtech-ui/student-dashboard-v2/payment-success-dialog/payment-success-dialog.component';
import { StudentPaymentActivePayload } from '@edtech-ui/core/models/student-courses-v2/student-payment-activate';
import { RazorPaymentVerifyPayload } from '@edtech-ui/core/models/mentors-sessions/post-razor-payment-verify';
import { RazorPaymentPayload } from '@edtech-ui/core/models/mentors-sessions/create-order-razorpay';
import { environment } from 'environments/environment';
import { ReferralCodeDialogBoxComponent } from '@edtech-ui/student-dashboard-v2/referral-code-dialog-box/referral-code-dialog-box.component';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
declare var Razorpay: any;

@Component({
	selector: 'app-pricing-model',
	standalone: true,
	imports: [CommonModule, BookDemoDailogBoxComponent, RouterModule, MatIconModule ,HasPermissionDirective],
	templateUrl: './pricing-model.component.html',
	styleUrl: './pricing-model.component.scss',
})
export class PricingModelComponent implements OnInit, OnDestroy {

	isMonthly = true;
	disableClose: boolean = true;
	planCodes = PLAN_CODES;
	upgradePricePlan = UpgradePricePlan;
	studentPackages!: StudentDataPackageProduct;
	starterProPackages!: StudentDataPackageProduct;
	currentSubscription!: CurrentSubscription;
	subscription = new Subscription();
	isLoading = false;
	studentEmail: string | null = null;
	selectedPriceId!: string;
	selectedProductId!: string;
	private orderId!: string;
	private razorpayOrderId!: string;
	private verifyOrderId!: string;
	private verifyPaymentId!: string;
	isReferralApplied = false;
	appliedReferralCode: string | null = null;
	useUsageCount = false;
	amountFromCreatedApi = 0;
	finalAmountAfterDiscount = 0;
	PermissionForStudents = PermissionForStudents;

	constructor(
		private dialog: MatDialog,
		private _paymentService: PaymentService,
		private _toastr: ToastrService,
		private ngZone: NgZone,
	) { }

	ngOnInit(): void {
		this.getStudentProductData();
		this.studentEmail = localStorage.getItem('email');
	}

	switchPlan(isMonthly: boolean) {
		this.isMonthly = isMonthly;
	}

	openDemoPopup(planName: UpgradePricePlan) {
		const planValue = this.isMonthly ? this.planCodes[planName].Monthly : this.planCodes[planName].Yearly;

		this.dialog.open(BookDemoDailogBoxComponent, {
			width: '500px',
			maxWidth: '95%',
			disableClose: false,
			autoFocus: true,
			panelClass: 'custom-dialog-container',
			data: {
				plan: planName,
				//plan: planValue , will this price value later,
				planName: planName,
				billing: this.isMonthly ? 'Monthly' : 'Yearly'
			}
		});
	}

	getStudentProductData() {
		this.subscription.add(
			this._paymentService.getStudentProducts().pipe(
				tap(response => {
					if (response.Success) {
						this.studentPackages = response.Data.products[0];
						this.starterProPackages = response.Data.products[1];
						this.currentSubscription = response.Data.current_subscription;

					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong .Please try again');
					return of(null);
				})
			).subscribe()
		);
	}

	postRazorPayment() {
		const paylod: RazorPaymentPayload = {
			product_id: this.selectedProductId,
			pricing_id: this.selectedPriceId,
			quantity: 1,
			referral_code: this.appliedReferralCode ?? undefined,
			use_usage_count: this.useUsageCount
		}
		this.isLoading = true;
		this.subscription.add(
			this._paymentService.postCreateOrderRazorPayment(paylod).pipe(
				tap(response => {
					if (response.Success) {
						this.orderId = response.Data.order_id;
						this.razorpayOrderId = response.Data.razorpay_order_id;
						this.amountFromCreatedApi = response.Data.amount;
						this.openRazorPayDialogBox();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this._toastr.error('Something went wrong. Please try again');
					return of(null);
				}),
			).subscribe()
		)
	}

	openRazorPayDialogBox() {

		const amountToPay = this.finalAmountAfterDiscount > 0
			? this.finalAmountAfterDiscount :
			this.selectedProductId === this.studentPackages.product_id ? this.studentPackages.price : this.starterProPackages.price;

		const options = {
			key: environment.razorPayKey,
			amount: amountToPay * 100,
			currency: 'INR',
			description: 'Mentor Session Payment',
			order_id: this.razorpayOrderId,
			prefill: {
				email: this.studentEmail,
			},
			theme: { color: '#3D348B' },
			handler: (response: any) => {
				this.ngZone.run(() => {
					this.postPaymentVerify(response);
				});
			}
		}

		const razorpay = new Razorpay(options);

		razorpay.on('payment.failed', (error: any) => {
			this._toastr.error('Payment failed. Please try again.');
		});
		razorpay.open();
	}

	postPaymentVerify(response: any) {
		const payload: RazorPaymentVerifyPayload = {
			razorpay_order_id: this.razorpayOrderId,
			razorpay_payment_id: response.razorpay_payment_id,
			razorpay_signature: response.razorpay_signature,
			order_id: this.orderId
		}
		this.subscription.add(
			this._paymentService.postRazorPaymentVerify(payload).pipe(
				tap(response => {
					if (response.Success) {
						this.verifyOrderId = response.Data.order_id;
						this.verifyPaymentId = response.Data.payment_id;
						this._toastr.success(response.Message);
						this.postStudentActiveSubscription();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong');
					return of(null);
				})
			).subscribe()
		)
	}

	postStudentActiveSubscription() {
		const payload: StudentPaymentActivePayload = {
			order_id: this.verifyOrderId,
			payment_id: this.verifyPaymentId
		}
		this.subscription.add(
			this._paymentService.postPaymentActiveSubscription(payload).pipe(
				tap(response => {
					if (response.Success) {
						this.openSuccessDialogBox();
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong. Please try again');
					return of(null);
				}),
			).subscribe()
		);
	}

	openSuccessDialogBox() {
		this.dialog.open(PaymentSuccessDialogComponent, {
			data: { amount: this.amountFromCreatedApi },
			disableClose: true
		})
	}

	openReferralCodeDialogBox(productId: string, pricingId: string, planName: string, price: number) {
		this.selectedProductId = productId;
		this.selectedPriceId = pricingId;
		const dialogRef = this.dialog.open(ReferralCodeDialogBoxComponent, {
			data: {
				pricing_id: this.selectedPriceId,
				plan_name: planName,
				price: price
			},
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			if (!result) return;

			this.isReferralApplied = result.isReferralApplied;

			if (result.isReferralApplied) {
				this.finalAmountAfterDiscount = result.discountedPrice;
				this.appliedReferralCode = result.referralCode;
				this.useUsageCount = result.use_usage_count;
			} else {
				this.finalAmountAfterDiscount = 0;
				this.appliedReferralCode = null;
				this.useUsageCount = false;
			}
			this.postRazorPayment();
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}